module.exports = __webpack_public_path__ + "static/media/sopt6ru.8705b39c.pdf";